'use client';

import dynamic from 'next/dynamic';
import { useAssistantPopup } from './AssistantContext';

const AssistantModal = dynamic(() => import('./AssistantModal'), { ssr: false });

export default function AssistantModalHost() {
  const { isOpen } = useAssistantPopup();

  return isOpen ? <AssistantModal /> : null;
}
